import { Phone, Mail, Clock } from "lucide-react";

const JACK = "https://customer-assets.emergentagent.com/job_chesterton-security/artifacts/yfjgic90_Jack%20Headshot.jpeg";

const Row = ({ Icon, label, children, testid }) => (
  <div data-testid={testid} className="flex items-start gap-5 py-6 border-b border-slate-800">
    <Icon className="w-5 h-5 text-amber-500 mt-1 shrink-0" strokeWidth={1.3} />
    <div className="flex-1">
      <p className="overline mb-2">{label}</p>
      <div className="text-slate-100 text-lg leading-relaxed">{children}</div>
    </div>
  </div>
);

export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-slate-950">
      {/* HERO */}
      <section data-testid="contact-hero" className="bg-slate-950 border-b border-slate-800 pt-20 pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <p className="overline mb-6 anim-up">Make Contact</p>
          <h1 className="anim-up anim-delay-1 font-serif text-5xl sm:text-6xl lg:text-8xl text-slate-50 leading-[0.95] tracking-tight max-w-4xl">
            A direct line to a <span className="italic text-amber-500">principal</span>.
          </h1>
          <p className="anim-up anim-delay-2 mt-8 text-slate-300 text-lg max-w-2xl leading-relaxed">
            Engagements begin with a confidential conversation — typically thirty
            minutes, always with a senior advisor, never with a sales associate.
          </p>
        </div>
      </section>

      {/* PRIMARY CONTACT */}
      <section className="bg-slate-950 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-7">
              <p className="overline mb-6">Get In Touch</p>
              <h2 className="font-serif text-4xl sm:text-5xl text-slate-50 leading-[1.05] tracking-tight mb-10">
                We answer our own <span className="italic text-amber-500">phone</span>.
              </h2>

              <Row Icon={Phone} label="Direct" testid="contact-phone">
                <a
                  href="tel:+16292476746"
                  className="text-slate-100 hover:text-amber-500 transition-colors link-underline"
                >
                  629-247-6746
                </a>
              </Row>
              <Row Icon={Mail} label="Confidential Intake" testid="contact-email">
                <a
                  href="mailto:info@chestertonsecurity.com"
                  className="text-slate-100 hover:text-amber-500 transition-colors link-underline"
                >
                  info@chestertonsecurity.com
                </a>
              </Row>
              <Row Icon={Clock} label="Hours" testid="contact-hours">
                Monday – Friday · 08:00 – 18:00 ET<br />
                <span className="text-slate-400 text-base">Principals on call 24/7 for active incidents.</span>
              </Row>
            </div>

            <div className="lg:col-span-5 lg:sticky lg:top-28">
              <div className="relative aspect-[4/5] overflow-hidden border border-slate-800">
                <img
                  src={JACK}
                  alt="Jack Shelton, Founding Principal of Chesterton Security"
                  className="w-full h-full object-cover grayscale-[20%]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6 right-6">
                  <p className="overline mb-2">Speak with</p>
                  <p className="font-serif text-2xl text-slate-50">Jack Shelton</p>
                  <p className="text-slate-300 text-sm">Founding Principal · Attorney</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QUIET CTA */}
      <section className="bg-slate-950">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-24 lg:py-32 text-center">
          <p className="overline mb-6">A Note On Discretion</p>
          <p className="font-serif text-3xl sm:text-4xl text-slate-50 leading-[1.15]">
            All inquiries are treated as <span className="italic text-amber-500">confidential</span>.
            Initial conversations are conducted under verbal NDA. We do not publish a
            client list, and we will not be the ones to mention you to anyone.
          </p>
        </div>
      </section>
    </div>
  );
}
